import React from 'react';
import validate from '../validate';
import plus from "../../../../assets/images/plus-circle2.svg";
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import {
    displayCurrency,
    addQuotationMergeGroup,
    editQuotationMergeGroup,
    getAllUnits,
} from "../../../../actions";
import { toast } from 'react-toastify';
import QuillEditor from '../../../../Components/EditorQuill';

function stripHtmlTags(value) {
    if (!value) return '';
    return value.replace(/<[^>]*>/g, '').trim();
}

const renderField = ({ input, placeholder, maxLength, defaultValue, type, readOnly, meta: { touched, error } }) => (
    <div>
        <label></label>
        <div>
            <input {...input} placeholder={placeholder} type={type} className="form-control" maxLength={maxLength}
                defaultValue={defaultValue}
                readOnly={readOnly} />
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
);

const renderSelectField = ({ input, meta: { touched, error }, children }) => (
    <div>
        <div>
            <select {...input} className='form-control form-select mt-4'>
                {children}
            </select>
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
)


class MergeGroupForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            quantity: 0,
            discount: 0,
            unitCost: 0,
            popup: this.props.show,
            disabled: true,
            dataObj: '',
            total: 0,
            validationError: '',
        }
        this.popupRef = React.createRef();
        this.addMergeGroup = this.addMergeGroup.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.getQuantity = this.getQuantity.bind(this);
        this.getDiscount = this.getDiscount.bind(this);
        this.getUnitCost = this.getUnitCost.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.scrollToDiv = this.scrollToDiv.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    scrollToDiv = () => {
        if (this.props.scrolled) {
            const div = document.getElementById('table-bluee');
            if (div !== null) {
                document.getElementById('table-bluee').scrollIntoView({ behavior: 'smooth', block: "start" });
            }
        } else {
            window.scroll({
                top: window.pageYOffset + 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    getUnitCost(e) {
        const unitCost = Number(e.target.value) || 0;
        const quantity = Number(document.querySelector('input[name="Quantity"]')?.value) || 0;
        const discount = Number(document.querySelector('input[name="discount"]')?.value) || 0;
        const discountAmount = (unitCost * quantity * discount) / 100;
        this.setState({
            unitCost,
            total: (unitCost * quantity) - discountAmount
        });
    }

    getQuantity(e) {
        const quantity = Number(e.target.value) || 0;
        const unitCost = Number(document.querySelector('input[name="unitCost"]')?.value) || Number(this.state.unitCost) || 0;
        const discount = Number(document.querySelector('input[name="discount"]')?.value) || 0;
        const discountAmount = (unitCost * quantity * discount) / 100;
        this.setState({
            quantity,
            total: (unitCost * quantity) - discountAmount
        });
    }

    getDiscount(e) {
        const discount = Number(e.target.value) || 0;
        const unitCost = Number(document.querySelector('input[name="unitCost"]')?.value) || Number(this.state.unitCost) || 0;
        const quantity = Number(document.querySelector('input[name="Quantity"]')?.value) || Number(this.state.quantity) || 0;
        const discountAmount = (unitCost * quantity * discount) / 100;
        this.setState({
            discount,
            total: (unitCost * quantity) - discountAmount
        });
    }

    getEligibleGroupIds() {
        const { locationGroups, locationId } = this.props;
        if (!Array.isArray(locationGroups) || !locationId) return [];
        return locationGroups
            .filter(g => g.locationId === Number(locationId) && !g.workSpace)
            .map(g => g.groupId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.groupMergeGroupSuccess !== this.props.groupMergeGroupSuccess) {
            this.setState({
                groupMergeGroupSuccess: this.props.groupMergeGroupSuccess,
                disabled: true,
                total: 0,
                discount: 0,
                unitCost: 0,
                quantity: 0,
                dataObj: ''
            });
            if (this.props.groupMergeGroupSuccess.status === 200) {
                this.props.getList();
                toast(this.props.groupMergeGroupSuccess.data);
                this.props.reset();
                this.props.getAmounts();
                this.props.onHide();
            } else {
                toast(this.props.groupMergeGroupSuccess.data || this.props.groupMergeGroupSuccess.message);
            }
        }
        if (prevProps.show !== this.props.show && this.props.show) {
            if (this.props.str === "mergeGroup") {
                const defaultUnitPrice = this.getLocationTotalAmount();
                if (defaultUnitPrice > 0) {
                    this.setState({
                        unitCost: defaultUnitPrice,
                        total: defaultUnitPrice
                    });
                    this.props.change('unitCost', String(defaultUnitPrice));
                }
            }
            if (this.props.str === "editMergeGroup" && this.props.data) {
                const group = this.props.data;
                const firstProduct = (group.productDetails && group.productDetails.length > 0) ? group.productDetails[0] : null;
                // Keep the raw HTML so bold/line-breaks load back into the editor (don't stripHtmlTags).
                const productName = firstProduct ? (firstProduct.productName || "") : "";
                const productQuantity = firstProduct && firstProduct.quantity !== undefined && firstProduct.quantity !== null
                    ? firstProduct.quantity
                    : 0;
                const unitCost = (firstProduct && firstProduct.unitCost)
                    ? firstProduct.unitCost
                    : (group.unitCost || group.totalAmount || 0);
                const fallbackUnitId = (firstProduct && firstProduct.unitId)
                    || group.unitId
                    || "";
                this.setState({
                    dataObj: productName,
                    total: group.totalAmount || 0,
                    discount: (firstProduct && firstProduct.discount !== undefined && firstProduct.discount !== null)
                        ? firstProduct.discount
                        : (group.discount || 0),
                    quantity: productQuantity,
                    unitCost: unitCost,
                });
                if (fallbackUnitId) {
                    this.props.change('unitId', String(fallbackUnitId));
                }
                if (unitCost) {
                    this.props.change('unitCost', String(unitCost));
                }
                if (productQuantity) {
                    this.props.change('Quantity', String(productQuantity));
                }
                const discountVal = (firstProduct && firstProduct.discount !== undefined && firstProduct.discount !== null)
                    ? firstProduct.discount
                    : group.discount;
                if (discountVal !== undefined && discountVal !== null) {
                    this.props.change('discount', String(discountVal));
                }
            }
        }
        if (prevProps.units_list !== this.props.units_list && this.props.show && this.props.str === "editMergeGroup" && this.props.data) {
            const group = this.props.data;
            const fallbackUnitId = group.unitId
                || (group.productDetails && group.productDetails.length > 0 ? group.productDetails[0].unitId : null)
                || "";
            if (fallbackUnitId) {
                this.props.change('unitId', String(fallbackUnitId));
            }
        }
        if (prevProps.locationGroups !== this.props.locationGroups) {
            if (this.props.str === "editMergeGroup") {
                const group = this.props.data;
                if (group) {
                    const firstProduct = (group.productDetails && group.productDetails.length > 0) ? group.productDetails[0] : null;
                    this.setState({
                        dataObj: firstProduct ? (firstProduct.productName || "") : "",
                        total: group.totalAmount || 0,
                        discount: (firstProduct && firstProduct.discount !== undefined && firstProduct.discount !== null)
                            ? firstProduct.discount
                            : (group.discount || 0),
                        quantity: (firstProduct && firstProduct.quantity !== undefined && firstProduct.quantity !== null)
                            ? firstProduct.quantity
                            : 0,
                        unitCost: (firstProduct && firstProduct.unitCost) ? firstProduct.unitCost : (group.unitCost || 0),
                    });
                }
            }
        }
    }

    handleClickOutside(e) {
        if (this.props.show && this.popupRef.current && !this.popupRef.current.contains(e.target)) {
            this.setState({
                total: 0,
                quantity: 0,
                discount: 0,
                unitCost: 0,
                dataObj: "",
                validationError: ""
            });
            this.props.reset();
            this.props.onHide();
        }
    }

    componentDidMount() {
        this.props.dispatch(getAllUnits());
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    getLocationTotalAmount() {
        const locationData = this.props.quoteLocations?.find(
            loc => loc.locationId === Number(this.props.locationId)
        );
        return locationData?.totalAmountWithoutSetCount || 0;
    }

    handleFormSubmit(e) {
        e.preventDefault();
        if (this.props.str !== "editMergeGroup") {
            const cleanName = stripHtmlTags(this.state.dataObj);
            if (!cleanName) {
                this.setState({ validationError: "Enter Product Name" });
                this.scrollToDiv();
                return;
            }

            this.setState({ validationError: '' });
        }
        this.props.handleSubmit(this.addMergeGroup)();
    }

    async addMergeGroup(formData) {
        this.scrollToDiv();
        // Preserve the rich-text HTML (bold, line breaks); it's rendered via parse() in ViewProducts.
        const cleanName = this.state.dataObj || "";

        if (this.props.str === "editMergeGroup") {
            const unitCostVal = formData.unitCost || String(this.getLocationTotalAmount());
            let submitData = {
                mergedGroupId: this.props.data?.mergedGroupId || this.props.data?.groupId,
                groupId: this.props.data?.groupId,
                locationId: Number(this.props.locationId),
                quotationId: Number(this.props.quotationId),
                groupName: cleanName,
                workSpaceGroupName: cleanName,
                quantity: Number(formData.Quantity) || 1,
                unitId: Number(formData.unitId),
                discount: Number(formData.discount) || 0,
                totalPrice: unitCostVal,
                unitPrice: unitCostVal,
                totalAmount: Number(this.state.total) || this.getLocationTotalAmount(),
                workSpace: true
            };
            this.setState({ disabled: false });
            this.props.dispatch(editQuotationMergeGroup(submitData));
        } else {
            const groupIds = this.getEligibleGroupIds();
            const defaultUnitPrice = this.getLocationTotalAmount();
            const unitCostVal = formData.unitCost || String(defaultUnitPrice);

            let data = {
                groupIds: groupIds,
                groupName: cleanName,
                workSpaceGroupName: cleanName,
                locationId: Number(this.props.locationId),
                quotationId: Number(this.props.quotationId),
                quantity: Number(formData.Quantity) || 1,
                unitId: Number(formData.unitId),
                discount: Number(formData.discount) || 0,
                totalPrice: unitCostVal,
                unitPrice: unitCostVal,
                totalAmount: Number(this.state.total) || defaultUnitPrice,
                workSpace: true
            };
            this.setState({ disabled: false });
            this.props.dispatch(addQuotationMergeGroup(data));
        }
    }

    handleChange(value) {
        this.setState({ dataObj: value });
    }

    render() {
        const { handleSubmit, show, onHide, reset, initialValues, str } = this.props;
        const { total, disabled } = this.state;

        return (
            <>
                <button onClick={() => {
                    reset();
                    this.setState({
                        total: 0,
                        popup: true,
                        quantity: "",
                        discount: "",
                        unitCost: 0,
                        dataObj: "",
                        validationError: ""
                    });
                }} className="group_product_btn" style={{ display: "none" }} >
                    <img src={plus} alt="" />
                    Add Group
                </button>
                {show ? <div
                    ref={this.popupRef}
                    className='mini-popup product_pop'
                    show={show}
                    id="mini_pop"
                    onHide={() => {
                        this.setState({
                            total: 0,
                            quantity: 0,
                            discount: 0,
                            unitCost: 0,
                            dataObj: "",
                            validationError: ""
                        });
                        reset();
                        onHide();
                    }}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered >
                    <div className="modal-staff-here main">
                        <form onSubmit={this.handleFormSubmit}>
                            <Row className="modal-row" >
                                <Col md={1} >
                                    <i class="fas fa-arrow-left" style={{ marginTop: "20px" }} onClick={() => {
                                        this.setState({
                                            popup: false,
                                            total: 0,
                                            quantity: 0,
                                            discount: 0,
                                            unitCost: 0,
                                            dataObj: "",
                                            validationError: ""
                                        });
                                        reset();
                                        onHide();
                                    }}></i>
                                </Col>
                                <Col md={11} style={{ marginLeft: "-70px" }}>
                                    <QuillEditor value={this.state.dataObj} onEditorChange={this.handleChange} />
                                </Col>
                                {this.state.validationError && (
                                    <Col md={12}>
                                        <p style={{ color: '#e74c3c', fontSize: '12px', margin: '5px 0 0 50px' }}>
                                            {this.state.validationError}
                                        </p>
                                    </Col>
                                )}
                                <Col md={1} style={{ marginLeft: "40px" }}>
                                    <label class="form-control-placeholder" for="name" >Qty <span>*</span></label>
                                    <Field
                                        name="Quantity"
                                        type="text"
                                        component={renderField}
                                        onChange={this.getQuantity}
                                        maxLength="8"
                                    />
                                </Col>
                                <Col md={1}>
                                    <label class="form-control-placeholder" for="name" >Dis</label>
                                    <Field
                                        name="discount"
                                        type="text"
                                        component={renderField}
                                        onChange={this.getDiscount}
                                        defaultValue="0"
                                        maxLength="4"
                                    />
                                </Col>
                                <Col md={1}>
                                    <label class="form-control-placeholder" for="name" >  Unit Cost </label>
                                        <Field
                                            name="unitCost"
                                            type="text"
                                            component={renderField}
                                        onChange={this.getUnitCost}
                                        />
                                </Col>
                                <Col md={1}>
                                    <div className='add_product_new'>
                                        <div>
                                            <p>Total Cost</p>
                                            <h3 style={{ textAlign: "right" }}>
                                                {this.state.total ? this.state.total.toFixed(2) : "0.00"}
                                            </h3>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <label class="form-control-placeholder" for="name" >Unit Name</label>
                                    <Field name="unitId" component={renderSelectField} className='form-control form-select mt-4' >
                                        <option value="" disabled={true} hidden={true}> </option>
                                        {this.props.units_list && this.props.units_list.length > 0 ? this.props.units_list.map((unit, i) => (
                                            <option value={unit?.unitId} key={i}>{unit?.unitName}</option>)) : ""}
                                    </Field>
                                    <div className="triangle-bottom"></div>
                                </Col>
                                <Col md={2} style={{ marginTop: "4px" }}>
                                    {disabled ? <button type="submit" className="modal-btn sub-modal-btn" style={{ width: "130%" }}>
                                        {str === "mergeGroup" ? "Merge" : "Update"} Product
                                    </button> : <button type="button" className="modal-btn sub-modal-btn" style={{ width: "130%" }}>Loading....</button>}
                                </Col>
                                <Col md={5}></Col>
                            </Row>
                        </form>
                    </div>
                </div> : null}
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { str, data, locationId } = ownProps;
    const quoteLocations = state.qutation.quoteLocations;
    let initValues = {};

    if (str === "editMergeGroup" && data) {
        const firstProduct = (data.productDetails && data.productDetails.length > 0) ? data.productDetails[0] : null;
        const fallbackUnitId = (firstProduct && firstProduct.unitId)
            || data.unitId
            || "";
        const productQuantity = (firstProduct && firstProduct.quantity !== undefined && firstProduct.quantity !== null)
            ? firstProduct.quantity
            : (data.quantity || 1);
        const productDiscount = (firstProduct && firstProduct.discount !== undefined && firstProduct.discount !== null)
            ? firstProduct.discount
            : (data.discount || 0);
        const productUnitCost = (firstProduct && firstProduct.unitCost)
            ? firstProduct.unitCost
            : (data.unitCost || data.totalAmount || "");
        initValues = {
            Quantity: String(productQuantity),
            discount: String(productDiscount),
            unitCost: String(productUnitCost),
            unitId: String(fallbackUnitId),
        };
    } else {
        const locData = Array.isArray(quoteLocations)
            ? quoteLocations.find(l => l.locationId === Number(locationId))
            : null;
        const defaultUnitCost = locData?.totalAmountWithoutSetCount || "";
        initValues = {
            Quantity: "1",
            discount: "0",
            unitCost: defaultUnitCost ? String(defaultUnitCost) : "",
            unitId: "",
        };
    }

    return {
        initialValues: initValues,
        groupMergeGroupSuccess: state.qutation.groupMergeGroupSuccess,
        locationGroups: state.qutation.groupList,
        units_list: state.unit.units_list,
        quoteLocations: quoteLocations,
    }
}

const MergeGroup = reduxForm({
    form: "MergeGroupForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate
})(MergeGroupForm);

export default connect(mapStateToProps)(MergeGroup);
